import type { ReactElement, SVGProps } from "react";

export function ResolvedCheckIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M2.5 6.5L5 9L9.5 3.5"
        stroke="var(--color-teal, #14b8a6)"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
